var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAttach = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_2",
  "data-name": "Layer 2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 20"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Paper_Clip_Attachment",
  "data-name": "Paper Clip, Attachment"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m6,20c-3.31,0-6-2.69-6-6V4.5C0,2.02,2.02,0,4.5,0s4.5,2.02,4.5,4.5v8.5c0,1.65-1.35,3-3,3s-3-1.35-3-3v-6c0-.55.45-1,1-1s1,.45,1,1v6c0,.55.45,1,1,1s1-.45,1-1V4.5c0-1.38-1.12-2.5-2.5-2.5s-2.5,1.12-2.5,2.5v9.5c0,2.21,1.79,4,4,4s4-1.79,4-4V3c0-.55.45-1,1-1s1,.45,1,1v11c0,3.31-2.69,6-6,6Z"
})))));
export default SvgIconAttach;